import { render, staticRenderFns } from "./SchoolLetters.vue?vue&type=template&id=03a4d097&"
import script from "./SchoolLetters.vue?vue&type=script&lang=js&"
export * from "./SchoolLetters.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLetters.vue?vue&type=style&index=0&id=03a4d097&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports